/**
 * ToastHost — renders the queue of toasts from ToastContext. Place once at
 * the root of the app (after ToastProvider). Mirrors the RN Toast component
 * surface: variant-driven border color, optional `actionLabel + onPress`
 * surfaced as a chevron-decorated tap target.
 */

import { createPortal } from 'react-dom';
import Icon from './Icon';
import { useToast } from '../context/ToastContext';
import './ToastHost.css';

export default function ToastHost() {
  const { toasts, removeToast } = useToast();
  if (toasts.length === 0) return null;

  return createPortal(
    <div className="wg-toast-host">
      {toasts.map(t => {
        const variant = t.variant ?? t.type ?? 'info';
        const icon =
          variant === 'success'
            ? 'checkmark-circle'
            : variant === 'error'
              ? 'alert-circle'
              : variant === 'warning'
                ? 'warning'
                : 'information-circle';
        const onClick = t.onPress
          ? () => {
              t.onPress?.();
              removeToast(t.id);
            }
          : undefined;
        return (
          <div
            key={t.id}
            className={`wg-toast ${variant}${onClick ? ' actionable' : ''}`}
            role={onClick ? 'button' : 'status'}
            onClick={onClick}
          >
            <Icon name={icon} size={20} color="#fff" />
            <span className="wg-toast-message">{t.message}</span>
            {t.actionLabel && (
              <span className="wg-toast-action">
                {t.actionLabel}
                <Icon name="chevron-forward" size={16} color="#fff" />
              </span>
            )}
          </div>
        );
      })}
    </div>,
    document.body,
  );
}
